import React from 'react';
import { InlineStyleButton } from './InlineStyleButton';

export function StriketroughButton({ store, theme, env }) {
	return (
		<InlineStyleButton store={store} theme={theme} env={env} inlineStyle="STRIKETHROUGH">
			<i className="qa-ico-strike" title="删除线">~</i>
		</InlineStyleButton>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/inlineStylePlugin/StriketroughButton.jsx